import { Fragment } from 'react';
import { useIntl } from 'react-intl';

import { getChangeLogData, getSectionTitle, groupChangelogSections } from './formatters';

import type { MultiFlightEntityType } from 'sonata-static-storage/lib/common/common.types';
import type { ChangelogDiff } from './formatters';
import type { ChangelogType } from './types';

type Props = {
  changeType: ChangelogType;
  changes: ChangelogDiff[];
  entity: MultiFlightEntityType;
};

/** Changes of a single changelog document, grouped by section and sorted by order */
function ChangelogChanges({ changeType, changes, entity }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const groups = groupChangelogSections(getChangeLogData(changes, entity, changeType, formatMessage));

  return (
    <>
      {groups.map(({ items, section }) => (
        <div className="changelogModal__tableItem" key={section}>
          <div className="changelogModal__tableItemTitle">{getSectionTitle(section, formatMessage)}</div>
          {items.map(({ description, order }, index) => (
            <Fragment key={`${order}-${index}`}>{description}</Fragment>
          ))}
        </div>
      ))}
    </>
  );
}

export default ChangelogChanges;
